import { render, staticRenderFns } from "./ChartArea.vue?vue&type=template&id=e2395428&scoped=true&"
import script from "./ChartArea.vue?vue&type=script&lang=js&"
export * from "./ChartArea.vue?vue&type=script&lang=js&"
import style0 from "./ChartArea.vue?vue&type=style&index=0&id=e2395428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2395428",
  null
  
)

export default component.exports